import * as requestFromServer from "./SchoolReportsCrud";
import { callTypes, schoolReportSlice } from "./SchoolReportsSlice";
import { SchoolReportModules } from "../../../../../_helpers/Helpers";

const {actions} = schoolReportSlice;

export const getSchoolReports = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getSchoolReports(queryParams)
    .then(response => {
      dispatch(actions.schoolReportsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllSchoolReports = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllSchoolReports(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getSchoolReport = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewSchoolReport()
    .then(response => {
      dispatch(actions.schoolReportFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getSchoolReport(id)
    .then(response => {
      dispatch(actions.schoolReportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getReportModules = (queryParams, modules) => dispatch => {
  let reportModules = [...SchoolReportModules].map(module => {      
    const newModule = { ...module };
    const currentModule = modules.find(item => item.id === module.id);
    newModule.order = currentModule ? currentModule.order : 0;
    return newModule;
  });

  // Filtreleme İşlemleri
  if (queryParams.module) reportModules = reportModules.filter(item => item.module.includes(queryParams.module));
  if (queryParams.order) reportModules = reportModules.filter(item => item.order.toString() === queryParams.order);

  // Sıralama İşlemleri
  if (queryParams.sortField === "module") {
    if (queryParams.sortOrder === "asc") reportModules.sort((item1, item2) => item1.module.localeCompare(item2.module));
    else if (queryParams.sortOrder === "desc") reportModules.sort((item1, item2) => item2.module.localeCompare(item1.module));
  
  } else if (queryParams.sortField === "order") {
    const sortedModules = reportModules.sort((item1, item2) => {
      const aValid = item1.order > 0;
      const bValid = item2.order > 0;
      if (!aValid) return 1;
      if (!bValid) return -1;      
      if (!aValid && !bValid) return 0;
      if (queryParams.sortOrder === "asc") return item1.order - item2.order;
      if (queryParams.sortOrder === "desc") return item2.order - item1.order;
      return 0;
    });

    reportModules = sortedModules;
  }
  
  dispatch(actions.reportModulesFetched(reportModules));
};

export const getStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudents(queryParams)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSections = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getSections(queryParams)
    .then(response => {
      dispatch(actions.sectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getCourses = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getCourses()
    .then(response => {
      dispatch(actions.coursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveSchoolReport = schoolReport => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveSchoolReport(schoolReport)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const saveModules = (reportId, modules) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveModules(reportId, modules)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const saveReceipents = (reportId, ids) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveReceipents(reportId, ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const sendToPrint = schoolReport => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .sendToPrint(schoolReport)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteSchoolReports = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteSchoolReports(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanReportModulesState = () => dispatch => {
  dispatch(actions.reportModulesStateCleaned());
}

export const cleanReportStudentsState = () => dispatch => {
  dispatch(actions.reportStudentsStateCleaned());
}

export const cleanReportSectionsState = () => dispatch => {
  dispatch(actions.reportSectionsStateCleaned());
}

export const cleanSchoolReportsState = () => dispatch => {
  dispatch(actions.schoolReportsStateCleaned());
}